/**
 * True while the page is Keycloak's login return (`/?code=…&state=…`, or `error` instead of `code`) and there is an
 * auth service to complete it. The root layout shows a loading screen meanwhile instead of the logged-out home page.
 * Without an auth service the callback never runs, so this stays false and the page renders normally.
 */
export const isOidcCallbackUrl = (searchStr: string, hasAuthService: boolean): boolean => {
  if (!hasAuthService) return false;
  const params = new URLSearchParams(searchStr);
  return params.has('state') && (params.has('code') || params.has('error'));
};
